import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Metmast, MetmastSelection, MetmastSensorSelection, MetmastSignal } from 'app/shared/models/data-studio.model';

@Component({
    selector: 'app-metmasts-signals',
    templateUrl: './metmasts-signals.component.html',
    styleUrls: ['./metmasts-signals.component.scss'],
    standalone: false
})
export class MetmastsSignalsComponent implements OnChanges {

  @Input() metmasts: Metmast[];
  @Output() changeSignalsSelection = new EventEmitter<MetmastSignal[]>();

  allSignalsSelected = false;

  metmastsList: MetmastSelection[];
  totalSignals: number = 0;
  totalSignalsSelected: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.metmasts?.currentValue) {
      this.initSelection();
    }
  }

  selectAllMetmasts({checked}) {
    this.allSignalsSelected = checked;
    this.metmastsList?.forEach(metmast => {
      metmast.checked = checked;
      metmast.sensorsList?.forEach(sensor => {
        sensor.checked = checked;
        sensor.signalsList?.forEach(signal => {
          signal.checked = checked;
        });
        sensor.totalSelected = sensor.signalsList.filter(c => c.checked).length;
      });
      metmast.totalSelected = metmast.sensorsList.reduce((acc, sensor) => acc + sensor.totalSelected, 0);
    });
    this.totalSignalsSelected = this.allSignalsSelected ? this.totalSignals : 0;
    this.getSelectedSignalsList();
  }

  selectMetmast({checked}, metmast: MetmastSelection) {
    metmast.checked = checked;
    metmast.sensorsList?.forEach(sensor => {
      sensor.checked = checked;
      sensor.signalsList?.forEach(signal => {
        signal.checked = checked;
      });
      sensor.totalSelected = sensor.signalsList.filter(c => c.checked).length;
    });
    metmast.totalSelected = metmast.sensorsList.reduce((acc, sensor) => acc + sensor.totalSelected, 0);

    this.checkAllSelected();
    this.getSelectedSignalsList();
  }

  selectSensor({checked}, sensor: MetmastSensorSelection, metmast: MetmastSelection) {
    sensor.checked = checked;
    sensor.signalsList?.forEach(signal => {
      signal.checked = checked;
    });
    sensor.totalSelected = sensor.signalsList.filter(c => c.checked).length
    this.checkMetmastSelection(metmast);
    this.getSelectedSignalsList();
  }

  selectSignal({checked}, signal: MetmastSignal, sensor: MetmastSensorSelection, metmast: MetmastSelection) {
    signal.checked = checked;
    this.checkSensorSelection(sensor);
    this.checkMetmastSelection(metmast);
    this.getSelectedSignalsList();
  }

  private initSelection() {
    this.metmastsList = this.metmasts.map(metmast => ({
      ...metmast,
      total: metmast.sensorsList.flatMap(sensor => sensor.signalsList).length,
      totalSelected: 0,
      sensorsList: metmast.sensorsList.map(sensor => ({
        ...sensor,
        total: sensor.signalsList.length,
        totalSelected: 0,
        signalsList: sensor.signalsList.map(signal => ({
          ...signal,
          checked: false
        })),
        checked: false
      })),
      checked: false }));
    this.totalSignals = this.metmastsList.flatMap(metmast => metmast.sensorsList.flatMap(sensor => sensor.signalsList)).length;
    this.checkAllSelected();
  }

  private checkAllSelected() {
    this.totalSignalsSelected = this.metmastsList.reduce((acc, metmast) => acc + metmast.totalSelected, 0);
    this.allSignalsSelected = !!this.totalSignals && this.totalSignalsSelected === this.totalSignals;
  }

  private checkMetmastSelection(metmast: MetmastSelection) {
    metmast.checked = metmast.sensorsList?.every(sensor => sensor.checked);
    metmast.totalSelected = metmast.sensorsList.reduce((acc, sensor) => acc + sensor.totalSelected, 0);
    this.checkAllSelected();
  }

  private checkSensorSelection(sensor: MetmastSensorSelection) {
    sensor.checked = sensor.signalsList?.every(signal => signal.checked);
    sensor.totalSelected = sensor.signalsList.filter(c => c.checked).length
  }

  private getSelectedSignalsList() {
    const selectedSignals = this.metmastsList
      .flatMap(metmast => metmast.sensorsList
        .flatMap(sensor => sensor.signalsList.filter(signal => signal.checked)));
    this.changeSignalsSelection.emit(selectedSignals);
  }

}
